let LiveSearch = {
    url: '/' + window.langId + '/api/',
    query: undefined,
    typingTimer: undefined,
    renderCallback: undefined,
    $input: undefined,
    $search: undefined,
    $result: undefined,

    /**
     * Инициализация компонента
     */
    init(config = {}) {
        if (config.renderCallback != undefined) {
            LiveSearch.renderCallback = config.renderCallback;
        }

        let $search = $('[data-live-search]');
        let apiComponent = $search.data('live-search');
        let $input = $search.find('[data-live-search-input]');
        let $result = $search.find('[data-live-search-result]');

        if(
            apiComponent
            && $search.length
            && $input.length
            && $result.length
        ) {
            LiveSearch.$search = $search;
            LiveSearch.$input = $input;
            LiveSearch.$result = $result;
            LiveSearch.url = '/' + window.langId + '/api/' + apiComponent + '/';

            LiveSearch.setListeners();
        }
    },

    /**
     * Добавление событий
     */
    setListeners() {
        this.$input.on('input', () => {
            clearTimeout(this.typingTimer);

            this.query = this.$input.val();
            if(this.query.length >= 3) {
                this.sendAjax();
            }            
        });

        this.$input.on('blur', () => {
            setTimeout(() => {
                this.$result.hide();
            }, 240);
        });

        this.$input.on('focus', () => {
            if(this.query == undefined || this.query.length < 3) {
                return false;
            }

            this.$result.show();
        });
    },

    /**
     * Отправка запроса
     */
    sendAjax() {
        this.typingTimer = setTimeout(() => {

            let options = this.$search.data('live-search-options');
            var ajaxOptions = '';

            if (!!options){
                ajaxOptions = JSON.parse(options);
            }
            $.ajax({
                url: this.url,
                data: {
                    query: this.query,
                    options: ajaxOptions,
                },
                type: 'POST',
                success: (data) => {
                    if(data.result) {
                        this.$result.empty();
                        this.renderResult(data.result);
                    } else if (data.error) {
                        console.log(data.error);
                    }
                },
            });

        }, 400);
    },

    /**
     * Вывод полученных результатов на страницу
     *
     * @param {array} items
     */
    renderResult(items) {
        if(items.length == 0) {
            return false;
        }

        if (this.renderCallback != undefined) {
            // выполняем callback
            let resultHtml = this.renderCallback(items);
            this.$result.html(resultHtml);
        } else {
            $.each(items, (key, item) => {
                this.$result.append('<div class="item-live-search">'
                                    + '<a class="item-live-search__link"' + (item.isExternal ? ' target="_blank" ' : '') + 'href="'+ item.link +'">'+ item.name +'</a>'
                                    + '</div>');
            });
        }

        this.$result.show(0, function(){
            setTimeout(function(){
                var $nano = LiveSearch.$result.find('.nano');
                if($nano.length) $nano.nanoScroller();
            }, 100);
        });
    },
}

$(document).ready(function($) {
    //LiveSearch.init(); // живой поиск
})

export default {
    init: LiveSearch.init
};


// WEBPACK FOOTER //
// ./components/live-search.js